// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-settings-section {
  padding: 2rem;
  background: #f4f6f8;
  color: #334155;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.settings-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}
.settings-card .card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
  display: flex;
  align-items: center;
  gap: 8px;
}
.settings-card .card-title .info-tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.settings-card .card-title .info-tooltip-wrapper .info-icon {
  color: #004A9A;
  font-size: 0.9em;
  transition: color 0.2s;
}
.settings-card .card-title .info-tooltip-wrapper .tooltip-content {
  visibility: hidden;
  width: 280px;
  background-color: #1e293b;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px 12px;
  position: absolute;
  z-index: 100;
  bottom: 140%; /* Position above the icon */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  pointer-events: none;
  /* Arrow for the tooltip */
}
.settings-card .card-title .info-tooltip-wrapper .tooltip-content::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -6px;
  border-width: 6px;
  border-style: solid;
  border-color: #1e293b transparent transparent transparent;
}
.settings-card .card-title .info-tooltip-wrapper:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(-5px);
}

.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.toggle-row label {
  font-weight: 500;
  color: #475569;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #004A9A;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}
.toggle-switch input:focus + .toggle-slider {
  box-shadow: 0 0 1px #004A9A;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c4c4c4;
  transition: 0.4s;
  border-radius: 34px;
}
.toggle-switch .toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.add-column-container {
  display: flex;
  gap: 12px;
  margin-bottom: 1.5rem;
  align-items: center;
}
.add-column-container .new-col-input {
  flex: 1 1;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #334155;
  transition: border-color 0.2s;
}
.add-column-container .new-col-input:focus {
  outline: none;
  border-color: #004A9A;
  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);
}
.add-column-container .new-col-input::placeholder {
  color: #94a3b8;
}
.add-column-container .fixed-datatype {
  padding: 0.75rem 1rem;
  background: #f1f5f9;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.add-column-container .add-column-btn {
  padding: 0.75rem 1.5rem;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}
.add-column-container .add-column-btn:hover {
  background: #059669;
}
.add-column-container .add-column-btn:active {
  transform: scale(0.98);
}

.columns-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
}
.columns-list .column-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s;
}
.columns-list .column-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}
.columns-list .column-item .col-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}
.columns-list .column-item .col-info .col-number {
  font-weight: 600;
  color: #64748b;
  min-width: 25px;
  font-size: 14px;
}
.columns-list .column-item .col-info .col-name {
  font-weight: 500;
  color: #1e293b;
  font-size: 15px;
}
.columns-list .column-item .col-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.columns-list .column-item .col-right .col-datatype {
  color: #64748b;
  font-size: 13px;
  background: #e2e8f0;
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 500;
}
.columns-list .column-item .col-right .remove-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}
.columns-list .column-item .col-right .remove-btn-icon:hover {
  background: #dc2626;
  transform: scale(1.05);
}
.columns-list .column-item .col-right .remove-btn-icon:active {
  transform: scale(0.95);
}
.columns-list .column-item .col-right .remove-btn-icon svg {
  font-size: 14px;
}

.radio-group {
  display: flex;
  gap: 2rem;
}
.radio-group .radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  color: #475569;
}
.radio-group .radio-label input[type=radio] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #004A9A;
}
.radio-group .radio-label span {
  -webkit-user-select: none;
          user-select: none;
}
.radio-group .radio-label:hover {
  color: #004A9A;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}
.action-buttons .cancel-btn {
  background: #f1f1f1;
  color: #475569;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.action-buttons .cancel-btn:hover {
  background: #e2e8f0;
}
.action-buttons .save-btn {
  background: #004A9A;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.action-buttons .save-btn:hover:not(:disabled) {
  background: #003a7a;
}
.action-buttons .save-btn:disabled {
  background: #c4c4c4;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .case-settings-section {
    padding: 1rem;
  }
  .add-column-container {
    flex-direction: column;
    gap: 0.75rem;
  }
  .add-column-container .new-col-input,
  .add-column-container .fixed-datatype,
  .add-column-container .add-column-btn {
    width: 100%;
  }
  .column-item {
    flex-direction: column;
    gap: 0.75rem;
  }
  .column-item .col-info,
  .column-item .col-right {
    width: 100%;
    justify-content: space-between;
  }
  .action-buttons {
    flex-direction: column;
  }
  .action-buttons .cancel-btn,
  .action-buttons .save-btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/CaseSettings/CaseSettings.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AACJ;AACI;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACR;AAEQ;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;AAAZ;AAGY;EACI,cAAA;EACA,gBAAA;EACA,sBAAA;AADhB;AAQY;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA,EAAA,4BAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iFAAA;EACA,oBAAA;EAEA,0BAAA;AAPhB;AAQgB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAAA;AANpB;AAUY;EACI,mBAAA;EACA,UAAA;EACA,4CAAA;AARhB;;AAcA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAXJ;AAaI;EACI,gBAAA;EACA,cAAA;AAXR;;AAeA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AAZJ;AAcI;EACI,UAAA;EACA,QAAA;EACA,SAAA;AAZR;AAcQ;EACI,yBAAA;AAZZ;AAeQ;EACI,2BAAA;AAbZ;AAgBQ;EACI,2BAAA;AAdZ;AAkBI;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAhBR;AAkBQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAhBZ;;AAqBA;EACI,aAAA;EACA,SAAA;EACA,qBAAA;EACA,mBAAA;AAlBJ;AAoBI;EACI,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;AAlBR;AAoBQ;EACI,aAAA;EACA,qBAAA;EACA,2CAAA;AAlBZ;AAqBQ;EACI,cAAA;AAnBZ;AAuBI;EACI,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AArBR;AAwBI;EACI,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAtBR;AAwBQ;EACI,mBAAA;AAtBZ;AAyBQ;EACI,sBAAA;AAvBZ;;AA4BA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAzBJ;AA2BI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AAzBR;AA2BQ;EACI,mBAAA;EACA,qBAAA;AAzBZ;AA4BQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AA1BZ;AA4BY;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AA1BhB;AA6BY;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AA3BhB;AA+BQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AA7BZ;AA+BY;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA7BhB;AAgCY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA9BhB;AAgCgB;EACI,mBAAA;EACA,sBAAA;AA9BpB;AAiCgB;EACI,sBAAA;AA/BpB;AAkCgB;EACI,eAAA;AAhCpB;;AAuCA;EACI,aAAA;EACA,SAAA;AApCJ;AAsCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApCR;AAsCQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AApCZ;AAuCQ;EACI,yBAAA;UAAA,iBAAA;AArCZ;AAwCQ;EACI,cAAA;AAtCZ;;AA2CA;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AAxCJ;AA0CI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAxCR;AA0CQ;EACI,mBAAA;AAxCZ;AA4CI;EACI,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AA1CR;AA4CQ;EACI,mBAAA;AA1CZ;AA6CQ;EACI,mBAAA;EACA,mBAAA;AA3CZ;;AAgDA;EACI;IACI,aAAA;EA7CN;EAgDE;IACI,sBAAA;IACA,YAAA;EA9CN;EAgDM;;;IAGI,WAAA;EA9CV;EAkDE;IACI,sBAAA;IACA,YAAA;EAhDN;EAkDM;;IAEI,WAAA;IACA,8BAAA;EAhDV;EAoDE;IACI,sBAAA;EAlDN;EAoDM;;IAEI,WAAA;EAlDV;AACF","sourcesContent":[".case-settings-section {\r\n    padding: 2rem;\r\n    background: #f4f6f8;\r\n    color: #334155;\r\n}\r\n\r\n.settings-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1.5rem;\r\n    max-width: 1000px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.settings-card {\r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 1.5rem;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n    border: 1px solid #e0e0e0;\r\n    \r\n    .card-title {\r\n        font-size: 1.2rem;\r\n        font-weight: 600;\r\n        color: #004A9A;\r\n        margin-bottom: 1.2rem;\r\n        padding-bottom: 0.5rem;\r\n        border-bottom: 1px solid #f1f1f1;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n\r\n        // Tooltip Styles\r\n        .info-tooltip-wrapper {\r\n            position: relative;\r\n            display: inline-flex;\r\n            align-items: center;\r\n            \r\n\r\n            .info-icon {\r\n                color:  #004A9A;\r\n                font-size: 0.9em;\r\n                transition: color 0.2s;\r\n\r\n                // &:hover {\r\n                //     color: #004A9A;\r\n                // }\r\n            }\r\n\r\n            .tooltip-content {\r\n                visibility: hidden;\r\n                width: 280px;\r\n                background-color: #1e293b;\r\n                color: #fff;\r\n                text-align: center;\r\n                border-radius: 6px;\r\n                padding: 10px 12px;\r\n                position: absolute;\r\n                z-index: 100;\r\n                bottom: 140%; /* Position above the icon */\r\n                left: 50%;\r\n                transform: translateX(-50%);\r\n                opacity: 0;\r\n                transition: opacity 0.3s, transform 0.3s;\r\n                font-size: 12px;\r\n                font-weight: 400;\r\n                line-height: 1.5;\r\n                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n                pointer-events: none;\r\n\r\n                /* Arrow for the tooltip */\r\n                &::after {\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    top: 100%;\r\n                    left: 50%;\r\n                    margin-left: -6px;\r\n                    border-width: 6px;\r\n                    border-style: solid;\r\n                    border-color: #1e293b transparent transparent transparent;\r\n                }\r\n            }\r\n\r\n            &:hover .tooltip-content {\r\n                visibility: visible;\r\n                opacity: 1;\r\n                transform: translateX(-50%) translateY(-5px);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.toggle-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    \r\n    label {\r\n        font-weight: 500;\r\n        color: #475569;\r\n    }\r\n}\r\n\r\n.toggle-switch {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 50px;\r\n    height: 26px;\r\n    \r\n    input {\r\n        opacity: 0;\r\n        width: 0;\r\n        height: 0;\r\n        \r\n        &:checked + .toggle-slider {\r\n            background-color: #004A9A;\r\n        }\r\n        \r\n        &:checked + .toggle-slider:before {\r\n            transform: translateX(24px);\r\n        }\r\n        \r\n        &:focus + .toggle-slider {\r\n            box-shadow: 0 0 1px #004A9A;\r\n        }\r\n    }\r\n    \r\n    .toggle-slider {\r\n        position: absolute;\r\n        cursor: pointer;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        background-color: #c4c4c4;\r\n        transition: .4s;\r\n        border-radius: 34px;\r\n        \r\n        &:before {\r\n            position: absolute;\r\n            content: \"\";\r\n            height: 22px;\r\n            width: 22px;\r\n            left: 2px;\r\n            bottom: 2px;\r\n            background-color: white;\r\n            transition: .4s;\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n}\r\n\r\n.add-column-container {\r\n    display: flex;\r\n    gap: 12px;\r\n    margin-bottom: 1.5rem;\r\n    align-items: center;\r\n\r\n    .new-col-input {\r\n        flex: 1;\r\n        padding: 0.75rem;\r\n        border: 1px solid #e0e0e0;\r\n        border-radius: 8px;\r\n        font-size: 14px;\r\n        color: #334155;\r\n        transition: border-color 0.2s;\r\n        \r\n        &:focus {\r\n            outline: none;\r\n            border-color: #004A9A;\r\n            box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);\r\n        }\r\n\r\n        &::placeholder {\r\n            color: #94a3b8;\r\n        }\r\n    }\r\n\r\n    .fixed-datatype {\r\n        padding: 0.75rem 1rem;\r\n        background: #f1f5f9;\r\n        border: 1px solid #e0e0e0;\r\n        border-radius: 8px;\r\n        color: #64748b;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .add-column-btn {\r\n        padding: 0.75rem 1.5rem;\r\n        background: #10b981;\r\n        color: white;\r\n        border: none;\r\n        border-radius: 8px;\r\n        cursor: pointer;\r\n        font-weight: 500;\r\n        transition: background-color 0.2s;\r\n\r\n        &:hover {\r\n            background: #059669;\r\n        }\r\n\r\n        &:active {\r\n            transform: scale(0.98);\r\n        }\r\n    }\r\n}\r\n\r\n.columns-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n    margin-top: 1rem;\r\n\r\n    .column-item {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 1rem 1.25rem;\r\n        background: #f8fafc;\r\n        border: 1px solid #e2e8f0;\r\n        border-radius: 8px;\r\n        transition: all 0.2s;\r\n\r\n        &:hover {\r\n            background: #f1f5f9;\r\n            border-color: #cbd5e1;\r\n        }\r\n\r\n        .col-info {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 12px;\r\n            flex: 1;\r\n\r\n            .col-number {\r\n                font-weight: 600;\r\n                color: #64748b;\r\n                min-width: 25px;\r\n                font-size: 14px;\r\n            }\r\n\r\n            .col-name {\r\n                font-weight: 500;\r\n                color: #1e293b;\r\n                font-size: 15px;\r\n            }\r\n        }\r\n\r\n        .col-right {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 12px;\r\n\r\n            .col-datatype {\r\n                color: #64748b;\r\n                font-size: 13px;\r\n                background: #e2e8f0;\r\n                padding: 4px 12px;\r\n                border-radius: 6px;\r\n                font-weight: 500;\r\n            }\r\n\r\n            .remove-btn-icon {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                width: 32px;\r\n                height: 32px;\r\n                background: #ef4444;\r\n                color: white;\r\n                border: none;\r\n                border-radius: 6px;\r\n                cursor: pointer;\r\n                transition: all 0.2s;\r\n\r\n                &:hover {\r\n                    background: #dc2626;\r\n                    transform: scale(1.05);\r\n                }\r\n\r\n                &:active {\r\n                    transform: scale(0.95);\r\n                }\r\n                \r\n                svg {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.radio-group {\r\n    display: flex;\r\n    gap: 2rem;\r\n\r\n    .radio-label {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        cursor: pointer;\r\n        font-weight: 500;\r\n        color: #475569;\r\n\r\n        input[type=\"radio\"] {\r\n            width: 18px;\r\n            height: 18px;\r\n            cursor: pointer;\r\n            accent-color: #004A9A;\r\n        }\r\n\r\n        span {\r\n            user-select: none;\r\n        }\r\n\r\n        &:hover {\r\n            color: #004A9A;\r\n        }\r\n    }\r\n}\r\n\r\n.action-buttons {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 1rem;\r\n    margin-top: 1.5rem;\r\n    padding-top: 1.5rem;\r\n    border-top: 1px solid #e2e8f0;\r\n    \r\n    .cancel-btn {\r\n        background: #f1f1f1;\r\n        color: #475569;\r\n        border: 1px solid #e0e0e0;\r\n        border-radius: 8px;\r\n        padding: 0.75rem 1.5rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: all 0.2s;\r\n        \r\n        &:hover {\r\n            background: #e2e8f0;\r\n        }\r\n    }\r\n    \r\n    .save-btn {\r\n        background: #004A9A;\r\n        color: white;\r\n        border: none;\r\n        border-radius: 8px;\r\n        padding: 0.75rem 1.5rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: background-color 0.2s;\r\n        \r\n        &:hover:not(:disabled) {\r\n            background: #003a7a;\r\n        }\r\n        \r\n        &:disabled {\r\n            background: #c4c4c4;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .case-settings-section {\r\n        padding: 1rem;\r\n    }\r\n\r\n    .add-column-container {\r\n        flex-direction: column;\r\n        gap: 0.75rem;\r\n\r\n        .new-col-input,\r\n        .fixed-datatype,\r\n        .add-column-btn {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .column-item {\r\n        flex-direction: column;\r\n        gap: 0.75rem;\r\n\r\n        .col-info,\r\n        .col-right {\r\n            width: 100%;\r\n            justify-content: space-between;\r\n        }\r\n    }\r\n\r\n    .action-buttons {\r\n        flex-direction: column;\r\n\r\n        .cancel-btn,\r\n        .save-btn {\r\n            width: 100%;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
